<template>
  <span>
    <a-icon type="setting" @click="onEdit" />
    <a-modal title="成员管理" :visible="visible" @ok="onSubmit" @cancel="onCancel">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="成员" prop="users">
          <a-select v-model="form.users" mode="multiple" show-search :filter-option="utils.filterOption">
            <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </span>
</template>
<script>
import { userList } from '@/api/system/auth';
import { viewAdd, viewModify } from '@/api/project/view';
export default {
  props: {
    sourceData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      userData: [],
      form: {
        users: []
      }
    };
  },
  methods: {
    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },
    onEdit() {
      this.visible = true;
      if (this.sourceData.params) {
        this.form.users = this.sourceData.params.users || [];
      }
      this.getUserList();
    },
    onSubmit() {
      if (this.sourceData.id) {
        viewModify({ id: this.sourceData.id, name: '团队工作台', project_id: 0, category: 'worktable', view_type: 2, params: this.form }).then(() => {
          this.$message.success('保存成功');
          this.visible = false;
          this.$emit('change');
        });
      } else {
        viewAdd({ name: '团队工作台', project_id: 0, category: 'worktable', view_type: 2, params: this.form }).then(() => {
          this.$message.success('添加成功');
          this.visible = false;
          this.$emit('change');
        });
      }
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>
